(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("exam", [], factory);
	else if(typeof exports === 'object')
		exports["exam"] = factory();
	else
		root["exam"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 